import React, { useEffect, useState } from "react";
import styles from "./DEtalleBlog.module.css";
import { useLocation } from "react-router-dom";
import { ShareSection } from "./components/ShareSection";
import { RelatedArticles } from "./components/RelatedArticles";
import { getArticlesFromApi } from "../../../constants/post";
import { getImageUrl } from "../../../utils/imageUtils";
import { Cargando } from "../Cargando/Cargando";

export const DetalleBlog = () => {
  const location = useLocation();
  const [articles, setArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [loading, setLoading] = useState(false);

  // Normaliza el artículo recibido por state
  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);
      const data = await getArticlesFromApi();
      const mappedArticles = data.map((item, index) => {
        return {
          id: item.id || item._id || `article_${index + 1}`,
          _id: item._id || item.id || `article_${index + 1}`,
          title: item.title || "",
          description: item.description || "",
          largeDescription: item.content,
          image: item.imagesTitle || item.imageUrl || "",
          content: item.content,
          createdAt: item.createdAt,
        };
      });
      setArticles(mappedArticles);
      // Si vienes desde el Blog, selecciona el artículo pasado por state
      if (location.state && location.state.article) {
        const art = location.state.article;
        setSelectedArticle({
          ...art,
          id: art.id || art._id,
          _id: art._id || art.id,
        });
      } else {
        setSelectedArticle(mappedArticles[0]);
      }
      setLoading(false);
    };
    fetchArticles();
  }, [location.state]);

  // Limpiar el contenido HTML (quita el primer h1)
  const cleanContent = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const firstH1 = doc.querySelector("h1");
    if (firstH1) firstH1.remove();
    return doc.body.innerHTML;
  };

  // Maneja la selección de un artículo similar
  const handleSelectArticle = (articleId) => {
    const article = articles.find((art) => art.id === articleId || art._id === articleId);
    if (article) {
      setSelectedArticle(article);
    }
  };

  if (loading) {
    return <Cargando />;
  }

  if (!selectedArticle) {
    return <div>No se encontró el artículo</div>;
  }

  // Filtra los similares
  const similares = articles.filter((a) => a.id !== selectedArticle.id && a._id !== selectedArticle.id);

  const contenidoLimpio = cleanContent(selectedArticle.content);

  return (
    <main className={styles.detailBlogWrapper}>
      <h2 className={styles.titulo}>{selectedArticle.title}</h2>

      <div className={styles.detailBlogContent}>
        <ShareSection article={selectedArticle} />
        <div className={styles.detailArticleWrapper}>
          <div className={styles.contenedorCarruselSimilar}>
            {/* Renderizamos el contenido limpio */}
            <div
              className={styles.contenidoHTML}
              dangerouslySetInnerHTML={{ __html: contenidoLimpio }}
            />
          </div>
          <RelatedArticles
            relatedArticles={similares}
            onSelectArticle={handleSelectArticle}
          />
        </div>
      </div>
    </main>
  );
};
